import React from 'react';
import { Helmet } from 'react-helmet-async';

export const MetaManager: React.FC = () => {
  const viteEnv = import.meta.env.VITE_ENV;
  let robotsContent = 'index, follow'; // Default for production

  if (viteEnv === 'dev') {
    robotsContent = 'noindex, nofollow';
  } else {
    robotsContent = 'index, follow';
  }

  return (
    <Helmet>
      <title>NovoService - Услуги для эмигрантов в Румынии</title>
      <meta
        name='description'
        content='NovoService - платформа для эмигрантов из СНГ в Румынии. Найдите или предложите услуги: нотариус, адвокат, ремонт кондиционеров, СТО, маникюр, няни, репетиторы, уборка, переводчики, сантехника, массаж, фотографы, грузоперевозки и многое другое.'
      />
      <meta
        name='keywords'
        content='услуги Румыния, эмигранты СНГ, нотариус, адвокат, юридические консультации, ремонт кондиционеров, бытовая техника, СТО, шиномонтаж, маникюр, педикюр, няни, сиделки, репетиторы, парикмахер, уборка, клининг, переводчики, ремонт квартир, сантехника, электрика, массаж, косметология, фотограф, видеограф, мероприятия, грузоперевозки, переезды, курсы, психологи, ветеринары, ателье, IT-услуги, кейтеринг, NovoService'
      />
      <meta name='robots' content={robotsContent} />
      <meta name='author' content='NovoService' />
      <meta name='viewport' content='width=device-width, initial-scale=1.0' />

      {/* Open Graph tags for social media */}
      <meta
        property='og:title'
        content='NovoService - Услуги для эмигрантов в Румынии'
      />
      <meta
        property='og:description'
        content='Платформа для эмигрантов из СНГ в Румынии. Найдите нотариусов, мастеров маникюра, нянь, репетиторов, сантехников, фотографов, услуги уборки, грузоперевозки и многое другое на NovoService.'
      />
      <meta property='og:type' content='website' />
      <meta property='og:url' content='https://novoservice.net' />
      <meta
        property='og:image'
        content='https://novoservice.net/og-image.jpg'
      />
      <meta property='og:site_name' content='NovoService' />

      {/* Twitter Card tags */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta
        name='twitter:title'
        content='NovoService - Услуги для эмигрантов в Румынии'
      />
      <meta
        name='twitter:description'
        content='Найдите или предложите услуги для эмигрантов в Румынии: нотариус, маникюр, няни, репетиторы, ремонт, уборка, грузоперевозки и многое другое на NovoService.'
      />
      <meta
        name='twitter:image'
        content='https://novoservice.net/og-image.jpg'
      />

      {/* Language support */}
      <meta httpEquiv='content-language' content='ru, uk, ro' />
      <link rel='alternate' href='https://novoservice.net' hrefLang='ru' />
      <link rel='alternate' href='https://novoservice.net' hrefLang='uk' />
    </Helmet>
  );
};
